import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BusStopType } from '../models/enums/busStopType';
import { UUID } from '../models/model';
import { dateToDB } from '../shared/utils';

export interface TransportGroup {
    bus: UUID;
    driver?: UUID;
    passengers: {
        type: BusStopType;
        kid: UUID;
        stop: UUID;
    }[];
}
export interface Bus {
    id: UUID;
    registrationNumber: string;
    color: `rgb(${number}-${number}-${number})`;
    capacity: number;
    driver?: UUID;
}
export interface Driver {
    id: UUID;
    firstName: string;
    lastName: string;
}
export interface BusStop {
    id: UUID;
    name: string;
    description: string;
}
export interface Kid {
    id: UUID;
    name: string;
    morningStop: UUID;
}


@Injectable({ providedIn: 'root' })
export class TransportService {
    private readonly baseUrl = `${environment.api}/transports`
    private http = inject(HttpClient);

    public async load(date: Date) {
        const result = await firstValueFrom(this.http.get<{
            buses: Bus[];
            groups: TransportGroup[];
            drivers: Driver[];
            stops: BusStop[];
            kids: Kid[];
        }>(`${this.baseUrl}/by-date/${dateToDB(date.toString())}`));
        for (const kid of result.kids) {
            // TODO: fix kids on back end to return only stops ids and not entire stop
            kid.morningStop = (kid.morningStop as any)?.id;
        }
        return result;
    }
    public async save(date: Date, groups: TransportGroup[]) {
        return await firstValueFrom(this.http.post(
            `${this.baseUrl}/save`,
            { groups, date: dateToDB(date.toString()) },
        ));
    }
}
